(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flemar-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-flemar-sticky-atc]');
    if (!bar) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    var real = form && form.querySelector('[data-add-to-cart]');
    if (!form || !real || !('IntersectionObserver' in window)) return;

    var btn = bar.querySelector('[data-flemar-sticky-btn]');
    var txt = bar.querySelector('[data-flemar-sticky-text]');
    var price = bar.querySelector('[data-flemar-sticky-price]');
    var realTxt = real.querySelector('[data-add-to-cart-text]');
    var realPrice = document.querySelector('.product__price [data-product-price], .product__price');

    // the theme's own option selects (one per option, data-index="option1"...), and ours
    // Streamline attaches them to the form via form="<id>", not as descendants
    var realSelects = [].slice.call(document.querySelectorAll('select[data-variant-input][form="' + form.id + '"]'));
    if (!realSelects.length) realSelects = [].slice.call(form.querySelectorAll('select[data-variant-input]'));
    if (!realSelects.length) realSelects = [].slice.call(document.querySelectorAll('select[data-variant-input]'));
    var barSelects = [].slice.call(bar.querySelectorAll('[data-flemar-sticky-select]'));
    function realFor(sel) {
      var idx = sel.getAttribute('data-index');
      for (var i = 0; i < realSelects.length; i++) {
        if (realSelects[i].getAttribute('data-index') === idx) return realSelects[i];
      }
      return realSelects[barSelects.indexOf(sel)] || null;
    }

    function sync() {
      if (realTxt) txt.textContent = realTxt.textContent.trim();
      btn.disabled = real.disabled;
      if (realPrice) price.textContent = realPrice.textContent.trim();
      barSelects.forEach(function (sel) {
        var r = realFor(sel);
        if (!r) return;
        sel.value = r.value;
        for (var i = 0; i < sel.options.length; i++) {
          var ro = null;
          for (var j = 0; j < r.options.length; j++) if (r.options[j].value === sel.options[i].value) ro = r.options[j];
          sel.options[i].disabled = ro ? ro.disabled : false;
        }
      });
    }

    function show(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) sync();
    }

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      // visible only once the real button has scrolled above the viewport
      show(!e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(real);

    // size chosen in the bar -> push it into the theme's select so the theme does its usual work
    barSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var r = realFor(sel);
        if (!r) return;
        r.value = sel.value;
        r.dispatchEvent(new Event('change', { bubbles: true }));
        setTimeout(sync, 50);
      });
    });

    btn.addEventListener('click', function () {
      if (real.disabled) return;
      real.click();
    });

    // keep text/price/size in step with changes made in the page while the bar is visible
    document.addEventListener('change', function (evt) {
      if (bar.contains(evt.target)) return;
      if (bar.classList.contains('is-visible')) setTimeout(sync, 50);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
